/* eslint-disable react/prop-types */
import React from 'react';
import { ReactComponent as GlobeLogo } from '@bostonglobe/logos/logos/bglobe/bglobe-logo-white.svg';

import '~styles/modules/credits.scss';

const Credits = function ({ data }) {
  // console.log(data);
  const list = data.credits.map((credit, index) => (
    <li className="bentoncond-n6" key={index}>
      <span className="bentoncond-n4">
        {credit.role}
        {': '}
      </span>
      {credit.name}
    </li>
  ));

  return (
    <div id="credit__well">
      <div id="credits" className="text__well">
        <div className="logo-container">
          <GlobeLogo
            className="logo--lg"
            viewBox="0 0 500 67"
            width={301}
            height={34}
          />
        </div>
        <ul className="credit-list">
          {list}
        </ul>
        <p id="copyright" className="bentoncond-n4">
          © 2021 Boston Globe Media Partners, LLC
        </p>
      </div>
    </div>
  );
};

export default Credits;
